import React, { FC, useState } from "react";
import DialogLayout from "../DialogLayout";
import Typography from "../../components/Typography/Typography";
import ASSETS from "../../assets";
import Button from "../../components/Button/Button";

interface IProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  domain?: string;
  onConfirmDelete?: () => void;
}

const DeleteDomain: FC<IProps> = ({ open, setOpen, domain, onConfirmDelete }) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirmDelete = async () => {
    try {
      setLoading(true);
      if (onConfirmDelete) {
        await onConfirmDelete();
      }
    } catch (err: any) {
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DialogLayout open={open}>
      <div className="w-full max-w-[400px] p-[25px] bg-white rounded-[15px] relative">
        <div
          className="absolute top-[25px] right-[25px] rounded-full size-[30px] bg-[#0000000D] cursor-pointer grid place-items-center"
          onClick={handleClose}
        >
          <img src={ASSETS.cross} alt="" />
        </div>
        
        <div className="flex flex-col items-center text-center">
          {/* Warning Icon */}
          <div className="p-3 bg-red-100 rounded-full mb-4">
            <img src={ASSETS.delete} alt="Delete" className="w-8 h-8 text-red-600" />
          </div>
          
          <Typography variant="h2" className="font-bold title mb-2">
            Delete Domain
          </Typography>
          
          <Typography
            variant="body1"
            color="grey"
            className="mb-6 font-medium"
          >
            Are you sure you want to delete the domain <strong>{domain}</strong>? This action cannot be undone.
          </Typography>
          
          <div className="flex gap-3 w-full">
            <Button
              label="Cancel"
              variant="outlined"
              className="flex-1 h-[45px]"
              onClick={handleClose}
            />
            <Button
              label="Delete"
              variant="primary"
              className="flex-1 h-[45px] bg-red-600 hover:bg-red-700"
              onClick={handleConfirmDelete}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </DialogLayout>
  );
};

export default DeleteDomain;
